// @flow
import React from 'react';

import '../ui/article-snippet.css';

type Props = {
    seoTitle: String,
    seoKeywords: String,
    seoDescription: String
};

class ArticleSnippet extends React.Component<Props, State> {
    render() {
        const seoTitle = this.props.seoTitle;
        const seoKeywords = this.props.seoKeywords;
        const seoDescription = this.props.seoDescription;
        const keywordsArr = seoKeywords
            .trim()
            .replace(/\s\s+/g, ' ')
            .split(' ');
        const descriptionArr = seoDescription.trim().split(' ');

        return (
            <div className="article-snippet">
                <p className="article-snippet__hint">
                    Превью
                </p>

                {seoTitle &&
                    <div className="article-snippet__title">
                        {seoTitle}
                    </div>
                }

                {seoDescription &&
                    <div className="article-snippet__description">
                        {descriptionArr.map(
                            (item, i) => {
                                const reg = new RegExp(keywordsArr.join('|'), 'ig');
                                let result;

                                // если ключевых слов нет - выделять нечего
                                if (keywordsArr.join('').length && item.search(reg) !== -1) {
                                    result = <b key={item + i}>{item} </b>;
                                } else {
                                    result = <span key={item + i}>{item} </span>;
                                }
                                return result;
                            }
                        )}
                    </div>
                }
            </div>
        );
    }
}

export default ArticleSnippet;



// WEBPACK FOOTER //
// src/components/articles/ArticleSnippet.js